import * as React from 'react';
import * as Redux from 'redux';
import { createLogger } from 'redux-logger';
import { Provider } from 'react-redux';

import { Root } from '../components/root';
import { Main } from '../reducers';
import { IState } from '../interfaces';

/* For Google Analytics */
import * as BUILD from '../../config/config';
import ReactGA from 'react-ga';

ReactGA.initialize(BUILD.GA_ID);

/**
 * App component holds application state object
 */
export class App extends React.Component<{}, IAppState> {
  constructor(props: object) {
    super(props);
    this.state =  {
      store: Redux.createStore(Main, Redux.applyMiddleware(createLogger({ collapsed: true })))
    };
  }

  public render(): JSX.Element {
    return (
      <Provider store={this.state.store}>
        <Root />
      </Provider>
    );
  }
}

export interface IAppState {
  /** Instance of Redux Store */
  readonly store: Redux.Store<IState>;
}
